import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { Typeahead, withAsync } from "react-bootstrap-typeahead";
import axios from "../../../config/axios";

const AsyncTypeahead = withAsync(Typeahead);

const MunicipalitySelectBox = ({
  name,
  value,
  onChange,
  label,
  error,
  required = false,
  className = "mb-3",
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);

  const handleSearch = (searchName) => {
    setIsLoading(true);
    axios
      .get(`/api/v1/municipalities/autocomplete.json?name=${searchName}`)
      .then((response) => {
        setIsLoading(false);
        setOptions(response.data);
      })
      .catch((err) => console.log(err));
  };

  return (
    <Form.Group className={className}>
      <Form.Label>
        {label} {required && "*"}
      </Form.Label>
      <AsyncTypeahead
        id={name}
        isLoading={isLoading}
        labelKey={(option) => option.name}
        onSearch={handleSearch}
        placeholder="Nach Gemeinden suchen..."
        options={options}
        className="mb-3"
        onChange={(selected) => onChange?.(selected)}
        useCache={false}
        selected={value ? [value] : []}
        required={required}
      />
      {error && <span className="text-danger">{error}</span>}
    </Form.Group>
  );
};

export default MunicipalitySelectBox;
